import {FundProductPriceFilterModel, FundProductWithPricesModel} from '@spa/api';
import { environment } from 'appEnv/environment';
import {AmountControl, BaseControl, DatepickerControl} from 'appShared/classes';
import { ComponentTypesEnum } from 'appShared/enums';
import { FilterControlInterface } from 'appShared/interfaces';
import * as moment from 'moment';

import { ReportTableColumn, ReportTableConfigInterface, ReportTableData } from 'appShared/components';

export const ProductIdSelector = 'id';
export const ProductCodeSelector = 'code';

export const PanelProductPricesFilterControls = (): FilterControlInterface[] => {
    return [
        {
            name: FundProductWithPricesModel.getValueSelector(),
            placeholder: 'Price',
            controls: [
                new AmountControl({
                    name: FundProductPriceFilterModel.priceFromSelector(),
                    value: null,
                    placeholder: 'Price From',
                    validators: [],
                    componentType: ComponentTypesEnum.AmountInput,
                    currency: null,
                    sortIndex: 1,
                }),
                new AmountControl({
                    name: FundProductPriceFilterModel.priceToSelector(),
                    value: null,
                    placeholder: 'Price To',
                    validators: [],
                    componentType: ComponentTypesEnum.AmountInput,
                    currency: null,
                    sortIndex: 2,
                }),
            ],
            sortIndex: 1,
        },
        {
            name: FundProductWithPricesModel.getCreatedOnSelector(),
            placeholder: 'Created On',
            controls: [
                new DatepickerControl({
                    name: FundProductPriceFilterModel.createdOnFromSelector(),
                    value: null,
                    placeholder: 'Created On From',
                    maxDate: moment().format(environment.dateFormatLocalDate),
                    validators: [],
                    componentType: ComponentTypesEnum.Datepicker,
                    sortIndex: 1,
                }),
                new DatepickerControl({
                    name: FundProductPriceFilterModel.createdOnToSelector(),
                    value: null,
                    placeholder: 'Created On To',
                    maxDate: moment().format(environment.dateFormatLocalDate),
                    validators: [],
                    componentType: ComponentTypesEnum.Datepicker,
                    sortIndex: 2,
                }),
            ],
            sortIndex: 2,
        },
        {
            name: FundProductWithPricesModel.getCreatedBySelector(),
            placeholder: 'Created By',
            controls: [
                new BaseControl({
                    name: FundProductPriceFilterModel.createdBySelector(),
                    value: null,
                    placeholder: 'Created By',
                    validators: [],
                    componentType: ComponentTypesEnum.Text,
                }),
            ],
            sortIndex: 3,
        },
    ];
};


export const PanelSettingsProductEditPricesDataTableItems = (): ReportTableData[] => {
    return [
        new ReportTableData<string>({
            colId: FundProductWithPricesModel.getPriceDateSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: FundProductWithPricesModel.getIssuePriceSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: FundProductWithPricesModel.getAskPriceSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: FundProductWithPricesModel.getPenalRedemptionPriceSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: FundProductWithPricesModel.getNetAssetValueSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: FundProductWithPricesModel.getBidPriceSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: FundProductWithPricesModel.getCreatedOnSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<number>({
            colId: FundProductWithPricesModel.getCreatedBySelector(),
            value: null,
            hidden: false
        }),
    ];
};

export const PanelSettingsProductsEditPriceDataTableConfig: ReportTableConfigInterface = {
    rows: [],
    columns: [
        new ReportTableColumn({
            label: 'Date',
            selector: FundProductWithPricesModel.getPriceDateSelector(),
        }),
        new ReportTableColumn({
            label: 'Issue Price',
            selector: FundProductWithPricesModel.getIssuePriceSelector()
        }),
        new ReportTableColumn({
            label: 'Ask Price',
            selector: FundProductWithPricesModel.getAskPriceSelector()
        }),
        new ReportTableColumn({
            label: 'Penal Redemption Price',
            selector: FundProductWithPricesModel.getPenalRedemptionPriceSelector()
        }),
        new ReportTableColumn({
            label: 'Net Asset Value',
            selector: FundProductWithPricesModel.getNetAssetValueSelector()
        }),
        new ReportTableColumn({
            label: 'Bid Price',
            selector: FundProductWithPricesModel.getBidPriceSelector()
        }),
        new ReportTableColumn({
            label: 'Created On',
            selector: FundProductWithPricesModel.getCreatedOnSelector()
        }),
        new ReportTableColumn({
            label: 'Created By',
            selector: FundProductWithPricesModel.getCreatedBySelector()
        }),
    ],
    hiddenColumnIds: [],
    actionMenu: false
};
